import React from 'react';
import HeroSection from '../../HeroSection';
import { homeObjOne, homeObjTwo, homeObjThree, homeObjFour, homeObjFive, homeObjSix, homeObjSeven, homeObjEight, homeObjNine, homeObjTen } from './Data';
import Pricing from '../../Pricing';

function Home() {
  return (
    <>
      <HeroSection {...homeObjOne} />
      <HeroSection {...homeObjFive} />
      <HeroSection {...homeObjSix} />
      <HeroSection {...homeObjFour} />
      <HeroSection {...homeObjTen} />
      <HeroSection {...homeObjTwo} />
      <HeroSection {...homeObjSeven} />
      <HeroSection {...homeObjThree} />
    </>
  );
}

export default Home;
